import styled from "@emotion/styled";
import { GROW_WRAPPER_CLASS } from "../constants";
import { getPadding } from "./TextAreaStyled";
export const GrowWrapperStyled = styled("div")`
    display: grid;
    position: relative;
    width: 100%;
    height: 100%;
    div.${GROW_WRAPPER_CLASS} {
        /* Hidden from view, clicks, and screen readers */
        visibility: hidden;
        padding: ${getPadding};
    }
`;
//# sourceMappingURL=GrowWrapperStyled.js.map